/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-floating-promises */
import * as React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { WLTPContainer } from './style';
import { VueServiceHelper } from '../../consumptionAndEmission';
import type { WltpProps } from '../../consumptionAndEmission';
import { ContextLocaleService, ContextVueFormatter } from '../Providers';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';

type WLTPComponentsProps = {
  wltpTextValues: string[] | null;
  theme: string;
};

export const WLTPComponent: React.FC<WLTPComponentsProps> = (props) => {
  const { wltpTextValues } = props;
  const wltpFallback = useI18n(messages.wltpFallback);

  const localeService = React.useContext(ContextLocaleService);
  const vueFormatterService = React.useContext(ContextVueFormatter);

  const [vueTexts, setVueTexts] = React.useState([] as WltpProps[]);

  React.useEffect(() => {
    if (wltpTextValues && localeService && vueFormatterService) {
      VueServiceHelper.getConsumptionAndEmission(
        wltpTextValues,
        setVueTexts,
        vueFormatterService,
        localeService,
      );
    }
  }, [wltpTextValues, localeService, vueFormatterService]);

  return (
    <WLTPContainer>
      {vueTexts?.length ? (
        vueTexts?.map(
          ({
            formattedConsumption,
            formattedEmission,
            formattedCo2Class,
            formattedDischargedCo2Class,
            formattedDischargedConsumption,
          }) => (
            <Text
              tag="p"
              variant={{
                type: 'copy',
                order: process.env.IS_LEGACY ? '2' : '3',
                style: 'normal',
              }}
              key={Math.random()}
            >
              <span>
                {formattedConsumption && (
                  <span className="ca-wltp-items" tabIndex={-1} key={Math.random()}>
                    {formattedConsumption};
                  </span>
                )}
                {formattedEmission && (
                  <span className="ca-wltp-items" tabIndex={-1} key={Math.random()}>
                    {formattedEmission};
                  </span>
                )}
                {formattedCo2Class && (
                  <span className="ca-wltp-items" tabIndex={-1} key={Math.random()}>
                    {formattedCo2Class}
                    {formattedDischargedConsumption || formattedDischargedCo2Class ? ';' : ''}
                  </span>
                )}
                {formattedDischargedConsumption && (
                  <span className="ca-wltp-items" tabIndex={-1} key={Math.random()}>
                    {formattedDischargedConsumption}
                    {formattedDischargedCo2Class ? ';' : ''}
                  </span>
                )}
                {formattedDischargedCo2Class && (
                  <span className="ca-wltp-items" tabIndex={-1} key={Math.random()}>
                    {formattedDischargedCo2Class}
                  </span>
                )}
              </span>
            </Text>
          ),
        )
      ) : (
        <Text
          tag="p"
          variant={{
            type: 'copy',
            order: process.env.IS_LEGACY ? '2' : '3',
            style: 'normal',
          }}
        >
          {wltpFallback}
        </Text>
      )}
    </WLTPContainer>
  );
};
